var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { toDetail } from "../../helper/util";
import GlobalVue from "../../globalVue";
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import { EBillType } from "../../enum/EBillType";
import { UrlHelper } from '../../helper/UrlWrapper';
import DetailRecord from './DetailRecord.vue';
import MemberBalanceManageService from '../../api/MemberBalanceManageService';
import Header from './components/Header';
import { mapGetters } from 'vuex';
var defaultType = [{ type_name: '全部类型', type: 0 }];
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 0;
        _this.shopId = '';
        _this.logTypeSubtract = [2, 4];
        _this.typeList = defaultType;
        return _this;
    }
    Detail.prototype.created = function () {
        this.service = MemberBalanceManageService.getInstance();
    };
    Detail.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 120;
            }
        }, 300);
        this.getTypeList();
        this.getList();
    };
    Detail.prototype.search = function (filter) {
        this.$refs.pagination.clear();
        this.filter = filter;
        this.getList();
    };
    Detail.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    Detail.prototype.closeTab = function () {
        var closeBtnArr = $(".navTabsCloseBtn").prev();
        for (var i = 0; i < closeBtnArr.length; i++) {
            var titleList = ['余额流水详情'];
            if (titleList.includes($(closeBtnArr[i])[0].innerText)) {
                console.log($(closeBtnArr[i]).next());
                $(closeBtnArr[i]).next().click();
            }
        }
    };
    Detail.prototype.toDetail = function (row) {
        switch (row.log_type) {
            case 4:
                toDetail(EBillType.PurOrder, row.other_order_id, this);
                break;
            case 5:
                toDetail(EBillType.ShopAfterSales, row.other_order_id, this);
                break;
            default:
                this.closeTab();
                GlobalVue.$emit('addTab', {
                    component: DetailRecord,
                    title: '余额流水详情',
                    name: 'balance_detail',
                    showExist: true,
                    cprops: {
                        shopId: this.shopId,
                        keyword: row.other_order_code || row.order_code
                    }
                });
                break;
        }
    };
    Detail.prototype.getTypeList = function () {
        var _this = this;
        this.service.getTypeList().then(function (res) {
            var data = res.data.data;
            if (Array.isArray(data) && data.length) {
                _this.typeList = defaultType.concat(data);
            }
        });
    };
    Detail.prototype.initParams = function () {
        var pager = this.$refs.pagination.getPage();
        var params = __assign({}, this.filter, { shop_id: this.shopId });
        Object.assign(params, pager);
        return params;
    };
    Detail.prototype.exportData = function (filter) {
        var url = '/supplierclientapi/shop_finance/to_shop_finance_log_export';
        var params = this.initParams();
        for (var key in params) {
            var value = params[key];
            url = UrlHelper.addParam(url, key, value);
        }
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(['_trackEvent', '客户余额管理', '客户余额明细导出']);
    };
    Detail.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = this.initParams();
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getDetail(params).then(function (res) {
            var _a = res.data, data = _a.data, total = _a.total;
            var list = (data && data.items) || [];
            _this.listData = list;
            _this.total = total || 0;
        }).finally(function () {
            loadingInstance.close();
        });
    };
    Detail = __decorate([
        Component({
            components: {
                'list-header': Header
            },
            computed: __assign({}, mapGetters({
                user: 'user'
            }))
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
